<template>
  <div class="notification-container d-flex">
    <div class="section__left">
      <v-tabs class="notification-tabs" grow v-model="tab">
        <v-tab value="one"><span class="p-relative">Thông báo <span class="total" v-if="newNoti">{{newNoti}}</span></span></v-tab>
        <v-tab value="two">Các vấn đề</v-tab>
      </v-tabs>

      <!--Notifications tab-->
      <v-tabs-items class="mt-4" v-model="tab">
        <v-tab-item class="pa-0">
          <div class="tab-header d-flex justify-space-between px-3">
            <span>THÔNG BÁO</span>
            <v-icon id="show-more-noti" class="vcs-icon-three-dot primary2-900"></v-icon>
            <v-menu activator="#show-more-noti" location="bottom">
              <v-list class="custom-notification-menu">
                <v-list-item>
                  <v-list-item-title>Đánh dấu đã đọc tất cả</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="notification-list px-3">
            <div v-for="(item, index) of arr" class="notification-item mt-2" :key="index" @click="showingDetail = !showingDetail">
              <div class="d-flex justify-space-between">
                <div class="notification-title">
                  <p class="text-truncate">Tiêu đề thông báo</p>
                  <span v-if="item" class="new-noti">Mới</span>
                </div>
                <span class="time">4 phút</span>
              </div>
              <div class="content mt-2">Content is the most prominent element of a notification. Secondary information, such as a timestamp, is smaller and consolidated above the primary content.</div>
            </div>
          </div>
        </v-tab-item>

        <!--Issues tab-->
        <v-tab-item>
          <div class="tab-header d-flex justify-space-between px-3">
            <span>CÁC VẤN ĐỀ</span>
            <v-icon id="show-more-issue" class="vcs-icon-three-dot primary2-900"></v-icon>
            <v-menu activator="#show-more-issue" location="bottom">
              <v-list class="custom-notification-menu">
                <v-list-item>
                  <v-list-item-title>Đánh dấu đã đọc tất cả</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="notification-list px-3">
            <div v-for="(item, index) of arr" class="notification-item mt-2" :key="index" @click="showingDetail = !showingDetail">
              <div class="d-flex justify-space-between">
                <div>
                  <div class="notification-title">
                    <p class="text-truncate">Tên vấn đề</p>
                    <span v-if="item" class="new-noti">Mới</span>
                  </div>
                  <span class="time">09:41:44 - 11/01/2023</span>
                </div>
                <span class="severity"><v-icon class="vcs-icon-severity-high yc-icon--small"></v-icon></span>
              </div>
              <div class="content mt-2">Content is the most prominent element of a notification. Secondary information, such as a timestamp, is smaller and consolidated above the primary content.</div>
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div class="section__right">
      <div v-if="showingDetail" class="notification-detail primary2-white h-full">
        <div class="detail-title">
          <p>Tiêu đề thông báo</p>
          <span class="sub-title">09:55:19 - 11/01/2023</span><br>
          <span class="sub-title">Mức độ nghiêm trọng: <v-icon class="vcs-icon-severity-medium yc-icon--small"></v-icon></span>
        </div>
        <div class="flex-1 d-flex flex-column">
          <div class="detail-content flex-1 mt-3">
            Phát hiện 03 tập tin độc thông qua tiến trình Quét toàn bộ. Chi tiết tập tin đã phát hiện:

            /storage/sdcard0/DCIM/Camera/ 1414240995236.jpg

            /storage/sdcard0/DCIM/Camera/1414240995236.jpg

            /storage/sdcard0/DCIM/Camera/1414240995236.jpg
          </div>
          <div class="d-flex">
            <v-btn
                :ripple="false"
                class="white--text primary2-950 flex-1 font-16 mr-3"
            >
              <v-icon class="icon-delete-circle mr-2"></v-icon>
              Xoá tất cả tệp tin
            </v-btn>
            <v-btn
                :ripple="false"
                class="white--text primary2-100 help-btn"
            >
              <v-icon class="vcs-icon-question-circle-outline primary2-800"></v-icon>
            </v-btn>
          </div>
        </div>
      </div>
      <div v-if="!showingDetail" class="logo text-center">
        <v-icon class="vcs-logo-msuite-black mx-auto"></v-icon>
        <div class="font-family-1 text-primary2-600 text-center pt-2">
          <div>Enterprise</div>
          <div class="font-weight-medium font-20">Mobility Suite</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "Notification",
  data() {
    return {
      tab: "",
      newNoti: 2,
      showingDetail: false,
      arr: ["1", "1", "1", "", "1", "", "", "", "", ""]
    }
  },

})
</script>
